import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import Components from 'portal-frontend';

import 'mintel-react-ui/dist/package/style.css';
import 'mintel-tokens/dist/assets/fonts.css';
import 'mintel-navigation/dist/style.css';

import './styles.scss';

type LoginProps = {
    input: {
        component: string;
        step?: string;
        errors: object;
        fields: {
            username: StringField;
            remember: BoolField;
            // eslint-disable-next-line camelcase
            current_step: StringField;
            csrf: StringField;
            password?: StringField;
        };
        forgotPasswordLink: string;
        fedLoginLink: string;
        registerLink: string;
        backLink: string;
    };
};

const Login = ({ input }: LoginProps): JSX.Element => {
    const showErrorMessage = Object.keys(input.errors).length > 0;
    return (
        <Components.LoginForm
            {...input}
            title="Client / Campus Login"
            showPasswordField={input.step === 'auth'}
            showUsernameField={input.step === 'username'}
            messageType={showErrorMessage ? 'alert' : 'info'}
            fields={input.fields}
            forgotPasswordLink={input.forgotPasswordLink}
        />
    );
};

const EmailRegistrationForm = ({
    input,
}: {
    input: EmailRegistrationProps;
}): JSX.Element => <Components.EmailRegistrationForm {...input} />;

const ForgotPasswordForm = ({
    input,
}: {
    input: RecoverPasswordProps;
}): JSX.Element => <Components.RecoverPassword {...input} />;

const ForgotPasswordEmailSent = ({
    input,
}: {
    input: RecoverPasswordProps;
}): JSX.Element => <Components.EmailSentPage {...input} />;

const ChangePasswordPage = ({
    input,
}: {
    input: ChangePasswordProps;
}): JSX.Element => <Components.ChangePassword {...input} />;

const AccessCode = ({ input }: { input: AccessCodeProps }): JSX.Element => (
    <Components.AccessCode {...input} />
);

const RegisterUserGroup = ({
    input,
}: {
    input: RegisterUserGroupProps;
}): JSX.Element => <Components.RegisterUserGroup {...input} />;

const ConfirmEmail = ({
    input,
}: {
    input: RegisterConfirmEmailProps;
}): JSX.Element => <Components.RegisterConfirmEmail {...input} />;

const RegisterForAccess = ({
    input,
}: {
    input: RegisterForAccessProps;
}): JSX.Element => <Components.RegisterForAccess {...input} />;

const OutOfOffice = ({ input}: { input: OutOfOfficeProps}): JSX.Element =>
<Components.OutOfOffice {...input} />;

const BaseComponent = (): JSX.Element => {
    const input = JSON.parse(
        document.getElementById('react-input')?.textContent || '{}',
    );

    const componentsMap: { [key: string]: React.ElementType } = {
        loginComponent: Login,
        forgotPasswordForm: ForgotPasswordForm,
        forgotPasswordEmailSent: ForgotPasswordEmailSent,
        changePassword: ChangePasswordPage,
        accessCode: AccessCode,
        registerChooseGroup: RegisterUserGroup,
        registerConfirmEmail: ConfirmEmail,
        registerWithEmail: EmailRegistrationForm,
        registerForAccess: RegisterForAccess,
        waitForApproval: Components.RegisterWaitForApproval,
        outOfOffice: OutOfOffice,
    };

    const componentName: string = input.component;

    const Component = componentsMap[componentName];
    return <Component input={input} />;
};

ReactDOM.render(<BaseComponent />, document.getElementById('exReactPage'));
